// Dead Center sound utilities — mirrors game/sound.js pattern.
// Pure Web Audio API synthesis: no audio files required.

let context;

export function unlockDcSound() {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    if (!context) context = new AudioContext();
    if (context.state === 'suspended') context.resume().catch(() => { /* Browser autoplay policy; gameplay continues silently. */ });
  } catch { /* No audio context available. */ }
}

/** Short percussive 'thock' — played instantly when the player taps a shape. */
export function playDcTap() {
  try {
    unlockDcSound();
    if (!context || context.state !== 'running') return;
    const now = context.currentTime;
    const osc = context.createOscillator();
    const gain = context.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(700, now);
    osc.frequency.exponentialRampToValueAtTime(310, now + 0.07);
    gain.gain.setValueAtTime(0.001, now);
    gain.gain.exponentialRampToValueAtTime(0.058, now + 0.007);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.085);
    osc.connect(gain);
    gain.connect(context.destination);
    osc.start(now);
    osc.stop(now + 0.1);
    osc.onended = () => { osc.disconnect(); gain.disconnect(); };
  } catch { /* Silent fallback. */ }
}

/**
 * Soft chime — played when the true centroid is revealed.
 * quality 'perfect' adds a higher second note for very accurate taps.
 */
export function playDcReveal(quality = 'normal') {
  try {
    unlockDcSound();
    if (!context || context.state !== 'running') return;
    const now = context.currentTime;
    const tone = (freq, at, dur, vol = 0.065) => {
      const osc = context.createOscillator();
      const g = context.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, at);
      g.gain.setValueAtTime(0.001, at);
      g.gain.exponentialRampToValueAtTime(vol, at + 0.013);
      g.gain.exponentialRampToValueAtTime(0.001, at + dur);
      osc.connect(g);
      g.connect(context.destination);
      osc.start(at);
      osc.stop(at + dur + 0.01);
      osc.onended = () => { osc.disconnect(); g.disconnect(); };
    };
    if (quality === 'perfect') {
      // Two-note chime for dead-center accuracy
      tone(880, now, 0.38, 0.08);
      tone(1320, now + 0.09, 0.3, 0.055);
    } else {
      tone(660, now, 0.32, 0.065);
    }
  } catch { /* Silent fallback. */ }
}

/** Optional haptic vibration on supported devices. */
export function dcHaptic(level = 'ordinary') {
  try {
    if (!navigator.vibrate) return;
    navigator.vibrate(
      level === 'perfect' ? [12, 28, 16] :
      level === 'good'    ? [8]           : 5
    );
  } catch { /* Vibration not available or denied. */ }
}
